module.exports = __webpack_public_path__ + "static/media/plus-circle.999a9b24.svg";